/*
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-08 21:34:17
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-12-29 16:15:17
 */
import axios from 'axios';
import { request, pcInstance, withoutCookieInstance } from '../utils/request';
import { generateToken } from '../utils/lib'

const getCategory = (type = 0) => {
  return request({
    method: 'get',
    url: `/api/v1/category/list?type=${type}`,
  });
}

const getNewList = (data, type = 0) => {
  return request({
    method: 'get',
    url: `/api/v1/post/index/list?type=${type}`,
    data,
  });
}

const getHotList = (data, type = 0) => {
  return request({
    method: 'get',
    url: `/api/v1/post/index/hotPostList?type=${type}`,
    data,
  });
}

const getFocusList = (data, type = 0) => {
  return request({
    method: 'get',
    url: `/api/v1/post/index/focusPostList?type=${type}`,
    data,
  });
}

const getCategoryList = (data, type = 0) => {
  return request({
    method: 'get',
    url: `/api/v1/post/index/categoryPostList?type=${type}`,
    data,
  });
}

const getArticleDetail = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/post/info`,
    data,
  });
}

const getBannerList = (type = 0) => {
  return request({
    method: 'get',
    url: `/api/v1/banners/showBanners?type=${type}`,
  });
}

const upArticle = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/post/isUp`,
    data,
  });
}

const postReply = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/bbsReply/postReply`,
    data,
  });
}

const postReplyList = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/bbsReply/postReplyList`,
    data,
  });
}

const postReplyAnonymous = (data) => {
  const { timestamp, token } = generateToken();
  return withoutCookieInstance({
    method: 'post',
    url: `/api/v1/bbsReply/anonymousReply`,
    data,
    headers: {
      'Shendeng-Api-User': 'xnshendeng',
      'Shendeng-Api-Timestamp': timestamp,
      'Shendeng-Api-Session': token,
    }
  });
}

const childReplyList = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/bbsReply/childReplyList`,
    data,
  });
}

const upAndDown = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/bbsUserReplyUpDown/upAndDown`,
    data,
  });
}

const postView = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/post/view`,
    data,
  });
}

const newPostView = (data, query = {}) => {
  const url = query.status ? `/api/v1/post/newView?status=${query.status}` : `/api/v1/post/newView`;
  return request({
    method: 'post',
    url,
    data,
    query
  });
}

const getSearchList = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/es/post/queryPostByKeyword`,
    data,
  });
}

const getUserInfo = () => {
  return request({
    method: 'get',
    url: `/api/v1/user/getSelfInfo`,
  });
}

const getUserDetail = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user/getById`,
    data,
  });
}

const getUserLevel = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user/bonus/level`,
    data,
  });
}

const getFansList = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user_fans/getFansList`,
    data,
  });
}

const getFollowList = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user_fans/getUserFollowing?type=0`,
    data,
  });
}

const follow = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/user_fans/following`,
    data,
  });
}

const cancelFollow = (data) => {
  return request({
    method: 'put',
    url: `/api/v1/user_fans/cancel_following`,
    data,
  });
}

const getUserPostList = (data, type) => {
  return request({
    method: 'get',
    url: `/api/v1/user/getUserPostList?type=${type}`,
    data,
  });
}

const getUpPostList = (data, type) => {
  return request({
    method: 'get',
    url: `/api/v1/user/getUpPostList?type=${type}`,
    data,
  });
}

const getCommentPostList = (data, type) => {
  return request({
    method: 'get',
    url: `/api/v1/user/getCommentPostList?type=${type}`,
    data,
  });
}

const getCollectPostList = (data, type) => {
  return request({
    method: 'get',
    url: `/api/v1/user/getCollectPostList?type=${type}`,
    data,
  });
}

const collectPost = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/post/isFavor`,
    data,
  });
}

const focusPost = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/bbs/isFocus`,
    data,
  });
}

const getMyCircle = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/forum/index/list`,
    data,
  });
}

const getTagList = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/bbsForumLabel/lists`,
    data,
  });
}

const getLabelList = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/category/postLabelList?type=1`,
    data,
  });
}

const getErps = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user/findUsers`,
    data,
  });
}

const postSave = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/post/save`,
    data,
  });
}
const postSaveAnonymous = (data) => {
  const { timestamp, token } = generateToken();
  return withoutCookieInstance({
    method: 'post',
    url: `/api/v1/post/anonymousSave`,
    data,
    headers: {
      'Shendeng-Api-User': 'xnshendeng',
      'Shendeng-Api-Timestamp': timestamp,
      'Shendeng-Api-Session': token,
    }
  });
}

const uploadImage = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/common/upload`,
    data,
  });
}

const getAnonymousAvatar = () => {
  return request({
    method: 'get',
    url: `/api/v1/user/getAnonymousAvatar?total=20`,
  });
}

const getAnonymousName = () => {
  return request({
    method: 'get',
    url: `/api/v1/user/getAnonymousName`,
  });
}

const deleteReplay = (data) => {
  return request({
    method: 'delete',
    url: `/api/v1/bbsReply/delete`,
    data,
  });
}

const signIn = () => {
  return request({
    method: 'post',
    url: `/api/v1/bbsUserCheckInDetail/save`,
  });
}

const signHistory = (data) => {
  return request({
    method: 'get',
    data,
    url: `/api/v1/user/checkInRecord`,
  });
}

const getMobilReportDetail = () => {
  return request({
    method: 'get',
    url: `/api/v1/users/behavior?loginType=h5`,
  });
}

const getReportDetail = (erp) => {
  return pcInstance({
    method: 'get',
    url: `/api/v1/users/behavior?loginType=pc${erp ? '&erp=' + erp : ''}`,
  })
}

const getViewHistory = (data, type) => {
  return request({
    method: 'get',
    url: `/api/v1/user/getViewedPostList?type=${type}`,
    data,
  });
}

const fetchPrevious = (data) => {
    return request({
    method: 'get',
    url: `/api/v1/post/next`,
    data,
  });
}

const vote = (data) => {
    return request({
    method: 'put',
    url: `/api/v1/bbsVote`,
    data,
  });
}

const getMyColumns = (data) => {
  return request({
    method: 'get',
    url: '/api/v1/column/index/list',
    data,
  })
}

const getColumnInfo = (data) => {
  return request({
    method: 'get',
    url: '/api/v1/column/view',
    data,
  })
}

const getCircleInfo = (data) => {
  return request({
    method: 'get',
    url: '/api/v1/forum/view',
    data,
  })
}

const getColumnPostList = (data) => {
  return request({
    method: 'get',
    url: '/api/v1/post/column/list',
    data
  })
}

const getCircleArticleList = (data) => {
  return request({
    method: 'get',
    url: '/api/v1/post/forum/list',
    data
  })
}

const updateColumnFavor = (data) => {
  return request({
    method: 'post',
    url: '/api/v1/column/isFavor',
    data
  })
}

const updateCircleFavor = (data) => {
  return request({
    method: 'post',
    url: '/api/v1/forum/isFavor',
    data
  })
}


const getUserFansNumber = (userIds) => {
  return request({
    method: 'get',
    url: '/api/v1/user_fans/numByErps',
    data: {
      userIds
    }
  })
}

const getUserBestPostList = (otherUserId) => {
  return request({
    method: 'get',
    url: '/api/v1/user/preferred',
    data: {
      otherUserId
    }
  })
}

const getUserFollowList = (data, type) => {
  return request({
    method: 'get',
    url: `/api/v1/user_fans/getUserFollowing?type=${type}`,
    data
  })
}

const shareSuccess = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user/shared/record`,
    data
  })
}

const bbsSubscribe = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user/chat/subscribe`,
    data
  })
}

const getDept = () => {
  return request({
    method: 'get',
    url: `/api/v1/forum/chat/dept`
  })
}

const getTopicList = (params) => {
  return request({
    method: "get",
    url: `/api/v1/chat/topic/chats`,
    data: params,
  });
}

const fetchTopicInfo = (topicText) => {
  return request({
    method: "get",
    url: `/api/v1/chat/topic/info?topicContent=${topicText}`,
  });
};

const fetchAuthorityTopicList = (data) => {
  return request({
    method: 'GET',
    url: '/api/v1/chat/topic/recommend',
    data
  })
}

const setBBsOpen = (data) => {
  return request({
    method: 'post',
    url: `/api/v1/forum/chat/open`,
    data
  })
}

const getBBSOpenStatus = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/forum/chat/isOpen`,
    data
  })
}

const searchTopic = (topicText = '') => {
  return request({
    method: "get",
    url: `/api/v1/chat/topic/list?content=${topicText}`,
  });
};

const getShareChatLinkKey = (data) => {
  return request({
    method: 'post',
    url: '/api/v1/chat/share',
    data
  })
}

const getShareChatLinkKeyByPostId = (postId) => {
  return request({
    method: 'post',
    url: `/api/v1/chat/getShareKey?postId=${postId}`,
  })
}

const getPostViewRecord = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/post/viewUser/list`,
    data
  })
}

const getReadRank = (data) => {
  return request({
    method: 'get',
    url: `/api/v1/user/readRank`,
    data
  })
}

const getEBookList = () =>  {
  return request({
    method: 'get',
    url: `/api/v1/knowledge/e-book/list`,
  })
}

// 获取推荐文章
const getRecommendPostList = (data) => {
  return request({
    method: 'get',
    url: '/api/v1/label/recommendPostList',
    data
  })
}

// 获取圈子匿名设置
const getCircleBbsIsReal = (data) => {
  return request({
    method: 'get',
    url: '/api/v1/forum/isReal',
    data
  })
}

const fetchActivityList = () => {
  return request({
    method: 'get',
    url: '/api/v1/1024/activity',
  })
}

const getLottery = () => {
  return request({
    method: 'get',
    url: '/api/v1/1024/lottery'
  })
}

const postLottery = () => {
  return request({
    method: 'post',
    url: '/api/v1/1024/lottery'
  })
}

const fetchPrize = (erp) => {
  return axios({
    method: 'get',
    url: 'http://api.m.jd.com/queryInteractiveRewardInfo',
    withCredentials: true,
    params: {
      appid: 'shendeng',
      functionId: 'queryInteractiveRewardInfo',
      loginType: 2,
      body: {
        encryptProjectId: 'sYbHvE53CrP2h6JD2uhibxN4rdo',
        encryptAssigmentIds: ['4Q32GL1fRjQxtjZfJboch8K5CRYz'],
        projectFailRewardsFlag: 1,
      },
      pin: erp,
    },
  })
}

const fetchPrizeList = (erp) => {
  return axios({
    method: 'get',
    url: 'http://api.m.jd.com/queryInteractiveInfo',
    withCredentials: true,
    params: {
    appid: 'shendeng',
    functionId: 'queryInteractiveInfo',
    loginType: 2,
    body: {
      encryptProjectId: 'sYbHvE53CrP2h6JD2uhibxN4rdo',
      encryptAssigmentIds: ['4Q32GL1fRjQxtjZfJboch8K5CRYz'],
      projectFailRewardsFlag: 1,
      sourceCode: 'ace1024cxy',
    },
    pin: erp,
  }
  })
}

export default {
  fetchPrize,
  fetchPrizeList,
  getLottery,
  postLottery,
  fetchActivityList,
  getCircleBbsIsReal,
  getRecommendPostList,
  getEBookList,
  getReadRank,
  getPostViewRecord,
  getShareChatLinkKeyByPostId,
  getShareChatLinkKey,
  getDept,
  getBBSOpenStatus,
  bbsSubscribe,
  shareSuccess,
  setBBsOpen,
  getUserFollowList,
  getUserBestPostList,
  getUserFansNumber,
  updateColumnFavor,
  updateCircleFavor,
  getColumnPostList,
  getCircleArticleList,
  getColumnInfo,
  getCircleInfo,
  getMyColumns,
  vote,
  fetchPrevious,
  getCategory,
  getNewList,
  getArticleDetail,
  getBannerList,
  getHotList,
  getFocusList,
  getCategoryList,
  upArticle,
  postReply,
  postReplyList,
  postReplyAnonymous,
  upAndDown,
  childReplyList,
  postView,
  getSearchList,
  getUserInfo,
  getUserDetail,
  getUserLevel,
  getFansList,
  getFollowList,
  follow,
  cancelFollow,
  getUserPostList,
  getUpPostList,
  getCommentPostList,
  getCollectPostList,
  collectPost,
  focusPost,
  getMyCircle,
  getErps,
  getTagList,
  postSave,
  postSaveAnonymous,
  uploadImage,
  getLabelList,
  getAnonymousAvatar,
  getAnonymousName,
  newPostView,
  deleteReplay,
  signIn,
  signHistory,
  getReportDetail,
  getMobilReportDetail,
  getViewHistory,
  getTopicList,
  fetchTopicInfo,
  searchTopic,
  fetchAuthorityTopicList
};